<template>
  <div id="app" class="wrapper">
    <div class="content-wrapper" ref="topo">
      <section class="content-header">
        <div
          style="padding-right: 0px; padding-left: 0px"
          class="container-fluid"
        >
          <div class="row mb-2">
            <div class="col-sm-6"></div>
            <div class="col-sm-6"></div>
          </div>
        </div>
      </section>
      <section class="content">
        <div
          style="padding-right: 0px; padding-left: 0px"
          class="container-fluid"
        >
          <div class="form-group">
            <div id="app">
              <br />
              <div
                style="
                  justify-content: center;
                  display: flex;
                  flex-flow: row nowrop;
                  align-items: center;
                "
              >
                <img
                  v-bind:src="
                    'https://apppanterafood.com.br/DeliveryCenter/' +
                    retornaContrato +
                    '/logo/topo_deli.jpg'
                  "
                />
              </div>
              <br />
              <div style="padding: 0" class="container" v-if="products">
                <ul style="margin: 0" class="list-group">
                  <li
                    style="border: none; margin-bottom: -1px; padding: 0"
                    class="list-group-item"
                    v-for="(classe, index) in filtroClasse"
                    :key="classe.nm"
                    :id="index"
                    :ref="classe.nm_id"
                  >
                    <div>
                      <div
                        style="
                          text-align: center;
                          font-size: 1.5rem;
                          color: white;
                          background-color: #960000;
                          color: #fff;
                        "
                        type="div"
                        class="btn-lg btn-block btn-secondary btn-dark"
                        :id="classe.nm_id"
                        @click="abrirFechar($event)"
                      >
                        {{ classe.nm }}
                      </div>
                      <img
                        v-bind:src="urlImage(contrato, classe.nm)"
                        @error="erroImagem($event)"
                        @click="abrirFechar($event)"
                        :class="classe.nm_id.split(' ').join('')"
                        :id="classe.nm_id"
                      />
                    </div>
                    <ul
                      style="margin: 0"
                      class="border-bottom border-top"
                      id="myList"
                      v-if="mostrarProduto && classeClicada == classe.nm_id"
                    >
                      <li
                        style="border: none; margin-top: 1px"
                        class="list-group-item border-bottom seletor"
                        v-if="
                          produto.classe == classe.nm &&
                          produto.ativo == 1 &&
                          (produto.qrCode_Go == 1 || produto.qrCode_Go == 2)
                        "
                        v-for="produto in products"
                        :key="produto.cd"
                        @click="
                          verificaordemprod(produto.cd, produto.nm, produto),
                            (cdproduto = produto.cd),
                            (nmproduto = produto.nm),
                            (vlproduto = produto.vl),
                            (ingredientesproduto = produto.ingredientes),
                            (classeproduto = produto.classe),
                            listandoordem(
                              produto.cd,
                              produto.nm,
                              produto.classe,
                              produto.ingrediente,
                              produto.vl,
                              nome_ordem.cd,
                              nome_ordem.cd_prod,
                              nome_ordem.nm,
                              nome_ordem.ordem,
                              nome_ordem.selecao
                            )
                        "
                      >
                        <div style="display: flex">
                          <div style="width: 100%; padding-right: 5px">
                            <label style="font-size: large" class="cor-preta">
                              <b>{{ produto.nm }}</b
                              ><br />
                              <!-- <b>{{ produto.classe }}</b
                              > -->
                            </label>

                            <label class="cor-cinza letra-pequena mt-2">{{
                              produto.ingredientes
                            }}</label>
                            <br />
                            <b style="color: #df0000; font-size: large">
                              <span
                                v-if="produto.vl_promo > 0"
                                class="promo-price"
                              >
                                <span class="risquinho">
                                  R$ {{ produto.vl }}
                                </span>
                                R$ {{ produto.vl_promo }}
                                <!-- valor de promoção -->
                              </span>
                              <span v-else> R$ {{ produto.vl }} </span>
                            </b>
                            <!-- <span class="cor-branca fundo p-1">
                            </span> -->
                            <br />
                            <br />

                            <!-- <div>
                              <button
                              style="color:	#FFF;background-color: #006400;"
                                
                                class="btn btn-dark"
                              >
                                Pedir
                              </button>
                            </div> -->
                          </div>
                          <!-- ,
                                    listandoad(
                                      produto.cd,
                                      produto.nm,
                                      produto.classe,
                                      produto.ingrediente,
                                      produto.vl,
                                      nome_ordem.ordem,
                                      nome_ordem.selecao,
                                      adicional.cd,
                                      adicional.cd_prod,
                                      adicional.qtd,
                                      adicional.vl,
                                      adicional.nm,
                                      adicional.cd_prod_pai
                                    ) -->

                          <picture align="right">
                            <img
                              style="
                                max-width: 100px;
                                max-height: 100px;
                                width: 100px;
                                height: 100px;
                              "
                              class="img-circular img-tam"
                              v-bind:src="
                                'https://apppanterafood.com.br/DeliveryCenter/' +
                                retornaContrato +
                                '/produtos/' +
                                produto.cd +
                                '.jpg'
                              "
                              v-bind:alt="produto.cd"
                              @error="erroImagemProduto($event)"
                            />
                          </picture>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <a
          id="irTopo"
          style="
            position: fixed;
            bottom: 30px;
            right: 20px;
            color: #fff !important;
            background-color: #006400;
          "
          class="btn btn-dark"
          @click="scrollMeTo('topo')"
          >Topo</a
        >
      </section>
    </div>
    <br />
    <footer class="main-footer" align="center">
      <b class="cor-preta">Todos os direitos reservados.</b><br />
      <b class="cor-preta"
        >&copy; 2022
        <a target="”_blank”" href="https://www.panterafood.com.br"
          >Pantera Food</a
        >.</b
      ><br />
      <img
        width="100"
        src="https://apppanterafood.com.br/DeliveryCenter/3/logo/pantera.svg"
      />
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Classe_prod from "../services/classe_prod";
import Ordem from "../services/nome_ordem";
import SecureLS from "secure-ls";
import Inis from "../services/inis";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "Products",
  data() {
    return {
      checkedNames: [],
      adicionaispergunta: [],
      search: "",
      classe_prods: [],
      classe_prod: {
        nm: "",
        ordem: "",
      },
      product: {
        cd: "",
        nm: "",
        classe: "",
        ingredientes: "",
        vl: "",
        vl_promo: "",
      },
      nome_ordens: [],
      nome_ordem: {
        cd: "",
        nm: "",
        ordem: "",
        cd_prod: "",
        selecao: "",
      },
      //adicionais: [],
      adicional: {
        cd: "",
        cd_prod: "",
        qtd: "",
        vl: "",
        tipo: "",
        nm: "",
        cd_sabor: "",
        ordem: "",
        obs: "",
        cd_prod_pai: "",
      },
      cdproduto: "",
      nmproduto: "",
      vlproduto: "",
      ingredientesproduto: "",
      classeproduto: "",
      index: 0,
      classes: [],
      classesNomes: [],
      classesNomes2: [],
      mostrarProduto: false,
      classeClicada: "",
      arrayMostrarProduto: [],
      errosImagem: [],
      contrato: "",
      cardapio: "",
    };
  },
  computed: {
    retornaContrato() {
      this.contrato = parseInt(process.env.VUE_APP_CONTRATO);

      return this.contrato;
    },
    filtroClasse() {
      var classesString = [];
      var classesObj = [];
      this.products.forEach((produto) => classesString.push(produto.classe));
      classesString
        .filter((classe, i) => classesString.indexOf(classe) === i)
        .forEach((c) => {
          this.classes.forEach((classe) => {
            if (c == classe.nm) {
              classesObj.push(classe);
            }
          });
        });
      return classesObj.sort(function (a, b) {
        return parseFloat(a.ordem) - parseFloat(b.ordem);
      });
    },
    ...mapGetters({
      //adicionais: 'allAdicionais',
      products: "allProducts",
      length: "getNumberOfProducts",
    }),
    //pesquisar QRCODE
  },
  methods: {
    urlImage(contrato, classe) {
      let encodedNm = Buffer.from(classe).toString("base64");
      return `https://apppanterafood.com.br/DeliveryCenter/${contrato}/classes/${encodedNm}.jpg?${performance.now()}`;
    },
    verificaordemprod(cd, nm, product) {
      if (this.cardapio == "0") {
        Ordem.verificaordem(cd).then((resposta) => {
          //alert(JSON.stringify(product));

          if (product.classe.toUpperCase() == "PIZZAS") {
            ls.set(
              "product" + process.env.VUE_APP_CONTRATO,
              JSON.parse(JSON.stringify(product))
            );
            this.$router.push("/pizzas");
          } else if (resposta.data === null) {
            //alert(JSON.stringify(product));
            ls.set(
              "product" + process.env.VUE_APP_CONTRATO,
              JSON.parse(JSON.stringify(product))
            );
            //window.location = 'https://localhost:8080/produtounico';
            /*  window.location = "https://192.168.1.27:8080/produtounico"; */
            //window.location = 'https://192.168.1.27/cardapio/produtounico';
            this.$router.push("/produtounico");

            // window.location = "https://apppanterafood.com.br/DeliveryCenter/3/cardapio/produtounico";
          } else {
            //alert(JSON.stringify(product));

            ls.set(
              "product" + process.env.VUE_APP_CONTRATO,
              JSON.parse(JSON.stringify(product))
            );
            this.$router.push("/perguntas");
            //window.location = 'https://localhost:8080/perguntas';
            /*   window.location = "https://192.168.1.27:8080/perguntas"; */
            //window.location = 'https://192.168.1.27/cardapio/perguntas';

            //window.location ="https://apppanterafood.com.br/DeliveryCenter/3/cardapio/perguntas";
          }
        });
      }
    },
    scrollMeTo(refName) {
      var element = this.$refs[refName];

      var top = element.offsetTop;

      element.scrollIntoView({ behavior: "smooth" });
    },
    scrollArray(refName) {
      var element = this.$refs[refName];

      var top = element[0].offsetTop;

      element[0].scrollIntoView({ behavior: "smooth" });
    },
    listarclasse() {
      Classe_prod.listarclasse().then((resposta) => {
        this.classe_prods = resposta.data;
        this.classe_prods.forEach((classe) => {
          var id = classe.nm;
          this.classesNomes.push({
            nm: classe.nm,
            ordem: classe.ordem,
            ativo: classe.ativo,
            nm_id: id,
          });
        });

        this.classes = this.classesNomes.sort(function (a, b) {
          return parseFloat(a.ordem) - parseFloat(b.ordem);
        });
        //console.log(this.classes)
      });
    },
    erroImagemProduto(event) {
      event.target.src =
        "https://apppanterafood.com.br/DeliveryCenter/" +
        this.retornaContrato +
        "/produtos/sem_imagem.jpg";
    },
    erroImagem(e) {
      var classe = e.target.id;

      document.querySelector("." + classe.split(" ").join("")).remove();
    },
    abrirFechar(e) {
      if (this.classeClicada == e.target.id) {
        this.mostrarProduto = !this.mostrarProduto;
      } else {
        this.mostrarProduto = true;
        this.classeClicada = e.target.id;
      }
      this.scrollArray(e.target.id);
    },
    listandoordem(ord) {
      Ordem.listandoordem(ord).then((resposta) => {
        this.nome_ordens = resposta.data;
      });
    },
    listar() {
      if (
        this.$route.query.serie != undefined &&
        this.$route.query.num_serie != undefined
      ) {
        var decodeSerie = Buffer.from(
          this.$route.query.serie,
          "base64"
        ).toString("ascii");
        var decodeNumSerie = Buffer.from(
          this.$route.query.num_serie,
          "base64"
        ).toString("ascii");

        localStorage.setItem(
          "serie" + process.env.VUE_APP_CONTRATO,
          decodeSerie
        );
        localStorage.setItem(
          "num_serie" + process.env.VUE_APP_CONTRATO,
          decodeNumSerie
        );
      }

      this.$store.dispatch("fetchProducts", { self: this });
    },
    async LojaIsActive() {
      var resposta = await Inis.listarInisCd("LOJA");
      if (resposta.data[0].vl == "1" && this.$store.state.loja == "") {
        this.$router.push("/lojas");
      }
    },
    async CardapioIsActive() {
      var resposta = await Inis.listarInisCd("CARDAPIO");
      resposta.data[0].vl == "1"
        ? (this.cardapio = "1")
        : (this.cardapio = "0");
    },
    ...mapActions(["addToCart"]),
  },
  async mounted() {
    await this.LojaIsActive(),
      await this.CardapioIsActive(),
      this.listar(),
      this.listarclasse(),
      this.listandoordem();
  },
};
</script>
<style>
.promo-price {
  font-weight: bold; /* negrito, se desejar */
}

.risquinho {
  text-decoration: line-through;
  color: Gray;
}
</style>
